import React from 'react';
import CoverArt from './CoverArt';
import './TrackArt.scss';

// A track's cover on the quiet "no artwork" tile — the Mixpedia look: a grey
// square with a ♫, which the artwork covers when there is some. The local art
// server answers `clear=1` with a transparent image for a track without art,
// so the tile shows through, in the current theme (a baked-in default image
// can't follow light/dark). The host's className sets the box: size, radius.
export const LOCAL_ART = 'http://localhost:3069/album-art';

/** A local art URL that shows the tile (not the gradient default) when the file has no art. */
export const clearDefault = (u) => (typeof u === 'string' && u.startsWith(LOCAL_ART) && !/[?&]clear=/.test(u)
    ? `${u}${u.includes('?') ? '&' : '?'}clear=1`
    : u);

const TrackArt = ({ src, size = 32, className = '', note = true, ...rest }) => (
    <span
        className={`track-art${note ? ' has-note' : ''}${className ? ` ${className}` : ''}`}
        style={{ '--track-art-note': `${Math.round(size * 0.38)}px` }}
    >
        {src && <CoverArt className="track-art-img" src={clearDefault(src)} size={size} {...rest} />}
    </span>
);

export default TrackArt;
